import { Router } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { TranslateModule } from "@ngx-translate/core";
import { Component, effect, inject, input } from "@angular/core";

import { MembershipsService } from "src/app/features/admin/services";
import { LookupsService, Service } from "src/app/core";
import { BreakpointCheckerDirective, ServiceCardComponent } from "src/app/shared";

@Component({
  selector: "app-services",
  standalone: true,
  imports: [TranslateModule, ServiceCardComponent, BreakpointCheckerDirective],
  templateUrl: "./services.component.html",
  styleUrl: "./services.component.scss",
})
export class ServicesComponent {
  private router = inject(Router);
  private lookupsService = inject(LookupsService);
  private servicesAsSignals = toSignal(this.lookupsService.getReservationServices());
  private membershipsService = inject(MembershipsService);

  title = input("SERVICES.SECTION", { alias: "pageTitle" });

  services: Service[] = [];
  sortedServices: Service[][] = [];
  requestStatus = toSignal(this.membershipsService.checkAddingService());

  breakpoints = ["(min-width: 960px)"];
  isNormalScreen: boolean = false;

  constructor() {
    effect(() => {
      const services = this.servicesAsSignals();
      if (!services) return;

      this.sortedServices = [services.slice(0, 4), services.slice(4, 7), services.slice(7)]; // isNormalScreen
      this.services = services;
    });
  }

  getBreakpointsStates(layoutStates: Record<string, boolean> | undefined) {
    this.isNormalScreen = layoutStates!["(min-width: 960px)"];
  }

  logOut() {
    localStorage.clear();
    this.router.navigate(["/"]);
  }

  isServiceHidden(service: Service, requestStatus: number): boolean {
    const isCompanyOrFriendsService = ["FriendsOfOmanMuseum", "TourismCompanies"].includes(service.code);
    return isCompanyOrFriendsService && requestStatus === 0;
  }
}
